<template>
  <div class="card border-radius-none">
    <div class="commandes__produits pdt-10px">

      <div class="commandes__details commandes__ligne--padding"
        :style='!!openDetail ? "--padding: 0 0 0.4em 0;" : "--padding: 0 0 0.6em 0;"'>

        <div style='--margin: 15px 0 0 0;'
            class='commandes__ligne-selecteurs'
            v-if="!ligneCommande.referencePersonnalise">
          <b-icon class="drag" icon="drag"
                  :class="{
                    'pointer-no-drop' : disabledDraggable,
                    'draggable-handle' : !disabledDraggable
                  }">
          </b-icon>
          <b-checkbox v-model="ligneCommande.selected" :disabled="disabled">
          </b-checkbox>
        </div>
        <div style='--margin: 1.1em 0 0 0;'
            class='commandes__ligne-selecteurs mgr-30px' v-else>
          <b-icon
            class="has-text-primary"
            icon="subdirectory-arrow-right">
          </b-icon>
        </div>

        <div class='commandes__ligne-produit'>
          <b-field :label="$t('detail.article.product')"
            custom-class="is-size-7 is-marginless has-text-link">
            <b-autocomplete
              :placeholder="$t('detail.article.search')"
              v-model="ligneCommande.produit.reference"
              :keep-first="false"
              :open-on-focus="false"
              :data="typesProduit"
              field="title"
              :disabled="(isCreditNote && !isAvoirLibre) || disabled"
              @select="selectedProduct"
              @input="searchProduct()">
              <template slot="empty">
                <div v-if="fetched">{{$t('detail.article.noResult')}}</div>
                <div v-else>{{$t('detail.article.search')}}</div>
              </template>
              <template slot-scope="props">
                <div class="dropdown-item is-paddingless" v-if="props.option.id">
                  <div class="columns is-marginless is-multiline">
                    <div class="column pdv-0">
                      <span class="has-text-weight-bold">
                        {{props.option.title}}
                      </span>
                      <span v-if="props.option.titleEnfant">
                        &nbsp;➔&nbsp;{{props.option.titleEnfant}}
                      </span>
                    </div>
                    <div class="column is-12 is-size-8 pdv-0"
                      v-if="props.option.adresse">
                      {{importedFunction.adressFullStringGetter(props.option.adresse)}}
                    </div>
                  </div>
                </div>
                <div v-else class="dropdown-item is-disabled is-paddingless">
                  {{$t(props.option.title)}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="commandes__ligne-libelle mgr-10px pdl-10px">
          <b-field custom-class="is-size-7 is-marginless has-text-link"
                   :label="$t('detail.article.libelle')">
            <b-input v-model="ligneCommande.libelle" :disabled="disabled"
            type="textarea" :rows="nbLignesLibelle">
            </b-input>
          </b-field>
        </div>
        <div v-if="showInputQuantiteDispo && !isCommandeAchatBailleur"
          class='commandes__ligne--is-max surface-regroupement' style='--max-width: 80px;'>
          <b-field
            :label="labelInputQuantiteDispo"
            custom-class="is-marginless ellipsis has-text-link is-size-7">
            <b-input v-model="quantiteDispo"
                     :disabled="disabled || ligneCommande.isAffecteLogistiquement"
              type="number"></b-input>
          </b-field>
        </div>
        <div v-if="ligneCommande.typeProduit === produitSalon"
             class='surface-regroupement commandes__ligne--is-max'>
          <b-field>
            <b-field :label="$t('detail.article.numeroStand')" class="width-50px mgr-10px"
                     custom-class="is-marginless ellipsis has-text-link is-size-7">
              <b-input v-model="ligneCommande.numStand"></b-input>
            </b-field>
            <b-field :label="$t('detail.article.surface')" class="width-50px"
                     custom-class="is-marginless ellipsis has-text-link is-size-7">
              <b-input v-model="ligneCommande.surface"></b-input>
            </b-field>
          </b-field>
        </div>

        <div class=" columns mgr-3px card-article-label-reseau-numerique"
          v-if="estProduitNumerique">
          <div class="column pdr-0"
            v-if="estProduitReseauNumerique">
            <b-field :label="$t('detail.article.ecranAssocies')"
              custom-class="is-size-7 ellipsis is-marginless has-text-link">
              <b-input v-model="nbEcranAssocies"
                type="number"
                disabled>
              </b-input>
            </b-field>
          </div>
          <div v-else class="column pdr-0">
          </div>
          <div class="column is-narrow"
              v-if="!isCommandeAchatBailleur">
            <b-field :label="$t('detail.article.saturation')"
              custom-class="is-size-7 is-marginless has-text-link">
              <div class="columns is-marginless is-vcentered">
                <span class="column is-narrow has-text-link is-size-6 is-paddingless">
                  {{$t('detail.article.saturationLabel')}}
                </span>
                <b-select @input="changeSaturation" expanded
                v-model="saturation" :disabled="disabled"
                class="column is-paddingless pdl-5px">
                  <option v-for="n in 12" :value="n" :key="n">
                    {{ n }}
                  </option>
                </b-select>
              </div>
            </b-field>
          </div>
        </div>

        <app-spec-produit-associe-location
          class='d-flex dates-regroupement mgt-28px'
          v-if="hasLocation && !showSpecProduitReseau"
          :ligneRegroupement="ligneCommande"
          :devisCommande="devisCommande"
          @updatePeriodeLocation="updatePeriodeLocation"
          :ouverturePopup= "ouverturePopup"
          :disabled="disabled"
        />

        <parution-presse :ligneCommande="ligneCommande"
                         :disabled="disabled"
                         class='d-flex dates-regroupement mgt-28px'
                         v-if="ligneCommande.typeProduit === produitPresse &&
                          ligneCommande.parution"
                          @applyParution="updateParution">
        </parution-presse>
        <produit-regroupement-produit-presse
          :disabled="disabled"
          v-if="isSponsoring"
          class='d-flex dates-regroupement mgt-28px'
          :ligneRegroupement="ligneCommande"
        />

        <app-spec-produit-reseau
          style='--x-start:4; --x-end: span 2; --y-start:1; --y-end: 2;'
          v-if="showSpecProduitReseau"
          :typeDcf="devisCommande.type"
          :ouverturePopup= "ouverturePopup"
          @reloadSimulationEtatProv="reloadSimulationEtatProv"
          @updatePeriodeLocation="updatePeriodeLocation"
          :devisCommande="devisCommande"
          :ligneCommande="ligneCommande"
          :isLigneRegroupementReseauInCreateCommandeFromDevis="
          isLigneRegroupementReseauInCreateCommandeFromDevis"
          @reloadTotalHt="calcul()"
          @calculAutoTlpe="calculAutoTlpe()"
          :disabled="disabled"
          :periodeTotalCalculTlpeAuto="periodeTotalCalculTlpeAuto"
          :loadingReseauFacesSelected="loadingReseauFacesSelected"
        />
        <div class="commandes__fin-ligne">
          <div class="has-text-weight-semibold" :class="mustBeItalicAndThrough">
            <span v-if="ligneCommande.totalHt" class="is-fullwidth ellipsis">
              {{ligneCommande.totalHt | formatDevise}}
            </span>
            <span v-else> {{ 0.00 | formatDevise }} </span>
          </div>
          <div>
            <a @click="toggleDetail()" class="iconArrowMenu"
              :class="{'iconRecouvrementArrowMenuOpen': openDetail}">
              <b-icon
                icon="arrow-right-drop-circle"
                type="is-default"
              >
              </b-icon>
            </a>
          </div>
          <b-dropdown position="is-bottom-left" aria-role="list"  :disabled="disabled">
            <a slot="trigger">
              <b-icon
                custom-class="has-text-icon-more"
                icon="dots-vertical">
              </b-icon>
            </a>
            <b-dropdown-item aria-role="listitem" @click="associer()"
                             v-if="!isCommandeAchatBailleur">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">
                    {{ $t('detail.article.associate')}}
                  </p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
                             :disabled="ligneCommande.isAffecteLogistiquement"
                             v-if="!isCommandeAchatBailleur"
                             @click="calculerSurfaceDispo()">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">
                    {{ $t('detail.article.calculerSurfaceDispo')}}
                  </p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="associerCommentaire()">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">
                    {{ $t('detail.article.associateCommentaire')}}
                  </p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
              v-if="!isCommandeAchatBailleur"
              @click="openPopupForDuplicate(ligneCommande.referencePersonnalise)">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">
                    {{ $t('general.button.dupliquer')}}
                  </p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
                             :disabled="ligneCommande.isAffecteLogistiquement || !canDelete"
                             @click="supprimerProduit()"
                             ref="actionSupprimee">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">{{ $t('detail.article.delete')}}</p>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>

      </div>

      <ligne-issue-commande v-if="devisCommande.references && devisCommande.references.length > 0
                              && ligneCommande.commandeId"
                            :is-edition="true"
                            :ligne-commande="ligneCommande"
                            :references-commande="devisCommande.references">
      </ligne-issue-commande>

      <option-blocage
        v-if="estAffichable"
        :ligneCommande="ligneCommande"
        :devisCommande="devisCommande"
        :disabled="disabled"
        @reloadTotalHt="calcul()"
        @loadingFaces="loadingReseauFacesSelected = $event"
        ref="ligneOptionBlocage">
      </option-blocage>

      <div class='commandes__ligne pdb-0' v-if='openDetail'>
        <qd-collapse :open="openDetail" animation="slide-fade" class='full-width pd-0'>
          <hr class="is-marginless" />
          <div v-for="(ligne, $index) in ligneCommande.lignesCommande" :key="$index">
            <app-sous-ligne-regroupement
              v-if="ligne.type !== typeCommentaire"
              ref="ligneRegroupement"
              :can-delete="canDelete"
              :class="getBackgroundColorClass"
              :isCreditNote="isCreditNote"
              :ligneRegroupement="ligneCommande"
              :lignesCommande="ligneCommande.lignesCommande"
              :ligneCommande="ligne"
              :indexLigne="$index"
              :ouverturePopup = "ouverturePopup"
              :error="error" :devisCommande="devisCommande"
              @reloadTotalHt="calcul()"
              @updatePeriodeLocation = updatePeriodeLocation
              @changementTva="updateMasqueLigne(ligneCommande.lignesCommande)"
              :disabled="disabled"
              :disponibilite="disponibilite"
              :modulePresseActive="modulePresseActive"
              :periodeTotalCalculTlpeAuto="periodeTotalCalculTlpeAuto"
              :activationYield="activationYield"
              :regimesTva="regimesTva"
            />
            <app-commentaire
              v-else
              :class="getBackgroundColorClass"
              :lignesCommande="ligneCommande.lignesCommande"
              :ligneCommande="ligne"
              :error="error"
              :indexLigne="$index"
              :regroupement=true
              :disabled="disabled"
            />
          </div>
        </qd-collapse>
      </div>
    </div>
    <b-modal v-model="popUpDuplicationLigne"
      class="modal"
      has-modal-card>
      <pop-up-duplication-ligne
        @makeDuplication="makeDuplication"
      />
    </b-modal>
    <b-modal v-model="errorPopUp"
             has-modal-card
             class="modal">
      <app-popup-erreur
        :messHeader="headerError"
      />
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import inProgress from '@/services/general/inProgress';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { ajoutLignesCommandeProduitFace } from '@/services/devisCommandes/ajoutProduit/ajoutProduitFace';
import { ajoutLignesCommandeProduitReseauTempo } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauTempo';
import { ajoutLignesCommandeProduitReseauLc } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauLc';
import { ajoutLignesCommandeProduitReseauMairie } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauMairie';
import { checkValidationLigneCommandeForDeleteAsync } from '@/api/logistique/demandeLogistique';
import copieReferencePersonnalise
  from '@/services/devisCommandes/regroupementPersonnalise/copieReferencePersonnalise';
import { ajoutLignesCommandeProduitReseauNumeriqueViaId }
  from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauNumerique';
import { ajoutLignesCommandeProduitEcranNumeriqueViaId }
  from '@/services/devisCommandes/ajoutProduit/ajoutProduitEcranNumerique';
import { getAllProduct } from '@/services/devisCommandes/getAllProduct';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import miseAJourCommentaire from '@/services/devisCommandes/miseAJourCommentaire';
import AppSpecProduitReseau from '@/components/devisCommandes/editionDevisCommande/specLigneArticle/produitRegroupementReseau';
import Commentaire from '@/components/devisCommandes/editionDevisCommande/m_ligneCommentaire';
import * as devisConf from '@/configuration/devisConf';
import getTarifPourDateLocation from '@/services/devisCommandes/getTarifPourDateLocation';
import ordreAddInRegroupement from '@/services/devisCommandes/ordreAddInRegroupement';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import * as saturationConvertisseur from '@/services/devisCommandes/numerique/saturationConvertisseur';
import { getAffectionOfProductFace, updateAffection, getAffectionOfProductReseauLc } from '@/services/affectation/affectation';
import updateQuantiteDispo from '@/services/devisCommandes/updateQuantiteDispo';
import optionBlocage from '@/components/devisCommandes/editionDevisCommande/ligneOptionBlocage';
import {
  SANS_SUITE, INDISPONIBLE, AUCUN, ANNULATION,
  BLOQUE,
  BLOQUE_COMMANDE,
} from '@/configuration/optionBlocage/optionBlocage';
import messageErreur from '@/services/general/messageErreur';
import { addReferenceEcheancierToLigneCommande }
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import deleteLignesEcheanciersInutiles from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';
import updateDatesAllEcheancierAuto from '@/services/commande/echeancierFacturation/updateDatesAllEcheancierAuto';
import { updateTarifProduitDiversTlpe, setPrixUnitaireTlpe } from '@/services/devisCommandes/updateTarifProduitDiversTlpe';
import calculTlpe from '@/services/dcf/tlpe/calculTlpe';
import parutionPresse
  from '@/components/devisCommandes/editionDevisCommande/specLigneArticle/parutionPresse';
import { MANDATAIRE_PAYEUR, REGIE } from '@/configuration/societe/societe';
import appSpecProduitAssocieLocation from '@/components/devisCommandes/editionDevisCommande/specLigneArticle/produitAssociesLocation';
import ligneIssueCommande from '@/components/factures/editionFacture/ligneIssueCommande';
import updateDateLigneCommande from '@/services/devisCommandes/ligneCommande/updateDateLignesCommande';
import updateInfoSousLigneRegroupement from '@/services/dcf/lignesDCF/updateInfoSousLigneRegroupement';
import * as gestionTarifUnitaire from '@/services/devisCommandes/ligneCommande/gestionTarifUnitaire';
import { createNamespacedHelpers } from 'vuex';
import getDisponibilite from '@/services/devisCommandes/getDisponibiliteTempo';
import { GUID_VIDE, INFINITE_DAY } from '@/configuration/general';
import validationLigneCommandeDemandeLogistique from '@/services/dcf/validation/validationLigneCommandeDemandeLogistique';
import produitRegroupementProduitPresse
  from '@/components/devisCommandes/editionDevisCommande/specLigneArticle/produitRegroupementProduitPresse';
import {
  ajoutLignesCommandeProduitSalon,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitSalon';
import {
  ajoutLignesCommandeProduitSponsoring,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitSponsoring';
import {
  ajoutLignesCommandeProduitAutre,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitAutre';
import {
  ajoutLignesCommandeProduitPresse,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitPresse';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import estDemandeManuelle from '@/services/devisCommandes/estDemandeManuelle';
import popUpDuplicationLigne from '@/components/devisCommandes/editionDevisCommande/p_duplicationLigne';
import initialisationOptionBlocage
  from '@/services/devisCommandes/optionBlocage/initialisationOptionBlocage';
import popupErreur from '@/components/general/popUpErreur';
import sousLigneRegroupement from './m_sousLigneRegroupement';

const Societes = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    lignesCommande: Array,
    ligneCommande: Object,
    error: Boolean,
    devisCommande: Object,
    isCreditNote: Boolean,
    isAvoirLibre: {
      type: Boolean,
      default: false,
    },
    sens: String,
    ouverturePopup: Boolean,
    disabledDraggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: true,
    },
    disponibiliteTempo: {
      type: Object,
      required: false,
      default: null,
    },
    modulePresseActive: {
      type: Boolean,
      required: true,
    },
    periodeTotalCalculTlpeAuto: {
      type: Boolean,
      required: true,
    },
    filtrerProduitParSociete: {
      type: Boolean,
      required: true,
    },
    activationYield: {
      type: Boolean,
      required: true,
    },
    regimesTva: {
      type: Array,
      required: true,
    },
  },
  components: {
    appSousLigneRegroupement: sousLigneRegroupement,
    AppSpecProduitReseau,
    appCommentaire: Commentaire,
    optionBlocage,
    ligneIssueCommande,
    appSpecProduitAssocieLocation,
    parutionPresse,
    produitRegroupementProduitPresse,
    popUpDuplicationLigne,
    appPopupErreur: popupErreur,
  },
  data() {
    return {
      fetched: false,
      quantiteDispo: this.ligneCommande.quantiteDispo * 100,
      selected: null,
      openDetail: !this.ligneCommande.referencePersonnalise,
      typesProduit: [],
      produitRegroupement: produitConf.CATEGORIE_REGROUPEMENT,
      produitPresse: produitConf.CATEGORIE_PRESSE,
      typeCommentaire: devisConf.COMMENTAIRE,
      produitSalon: produitConf.CATEGORIE_SALON,
      typeDevis: devisConf.TYPE_DEVIS,
      importedFunction: {
        adressFullStringGetter,
      },
      saturation: null,
      disponibilite: null,
      loadingReseauFacesSelected: false,
      popUpDuplicationLigne: false,
      errorPopUp: false,
      headerError: null,
    };
  },
  watch: {
    async quantiteDispo(newQuantiteDispo) {
      if (newQuantiteDispo < 0) {
        this.ligneCommande.quantiteDispo = 0;
        this.quantiteDispo = 0;
      } else {
        this.ligneCommande.quantiteDispo = newQuantiteDispo / 100;
        await this.calculAutoTlpe();
      }
    },
  },
  computed: {
    ...Societes.mapGetters({
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    isCommandeAchatBailleur() {
      return this.devisCommande.type === devisConf.TYPE_COMMANDE
        && this.devisCommande.module === devisConf.MODULE_BAIL;
    },
    interdireModificationBlocageCLGActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key);
    },
    getBackgroundColorClass() {
      if (this.ligneCommande.isDuplicated) return 'has-background-table-border';
      return 'has-background-table-second-color';
    },
    getRemiseTvaDefaut() {
      const agenceFind = this.agenceActive.find((agence) => {
        return agence.agenceId === this.devisCommande.agenceId;
      });
      if (!agenceFind || !agenceFind.regimeTvaId) return null;
      const regimeFind = this.regimesTva.find((regime) => {
        return regime.id === agenceFind.regimeTvaId;
      });
      return regimeFind ? regimeFind.tauxTva : null;
    },
    hasLocation() {
      return this.ligneCommande.lignesCommande.some((ligneEnfant) => {
        return ligneEnfant.typeProduit === produitConf.CATEGORIE_LOCATION;
      });
    },
    isSponsoring() {
      return this.ligneCommande.typeProduit === produitConf.CATEGORIE_SPONSORING;
    },
    isLigneRegroupementReseauInCreateCommandeFromDevis() {
      return (this.devisCommande.referenceId
        && this.devisCommande.id === GUID_VIDE
        && this.devisCommande.type === devisConf.TYPE_COMMANDE
        && this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT
        && this.ligneCommande.type === devisConf.REGROUPEMENT);
    },
    isLigneRegroupementReseauInDevisWithValidationModifBlocage() {
      return (estDemandeManuelle() && this.interdireModificationBlocageCLGActive
        && this.devisCommande.id
        && [devisConf.TYPE_DEVIS, devisConf.TYPE_COMMANDE].includes(this.devisCommande.type)
        && this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT
        && this.ligneCommande.type === devisConf.REGROUPEMENT
        && [BLOQUE, BLOQUE_COMMANDE].includes(this.ligneCommande.etatObtenu));
    },
    estSurFacture() {
      return this.devisCommande.type === devisConf.TYPE_FACTURE;
    },
    getCategoriesProduct() {
      if (this.devisCommande.type === devisConf.TYPE_COMMANDE
      && this.devisCommande.referenceId) {
        return [
          produitConf.CATEGORIE_UNITAIRE,
          produitConf.CATEGORIE_LOCATION,
          produitConf.CATEGORIE_DIVERS,
          produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE,
          produitConf.CATEGORIE_REGROUPEMENT_LC,
          produitConf.CATEGORIE_ECRAN_NUMERIQUE,
        ];
      }
      return null;
    },
    mustBeItalicAndThrough() {
      if (this.devisCommande.type === devisConf.TYPE_DEVIS) {
        if (this.ligneCommande.type === devisConf.REGROUPEMENT
          && this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT
          && (this.ligneCommande.etatObtenu === SANS_SUITE
            || this.ligneCommande.etatObtenu === INDISPONIBLE
            || this.ligneCommande.etatObtenu === ANNULATION)) {
          return { 'is-italic': true, textDecorationLineThrough: true };
        }
      }
      return {};
    },
    estAffichable() {
      return this.ligneCommande.type === devisConf.REGROUPEMENT
      && this.ligneCommande.typeProduit === this.produitRegroupement
      && this.devisCommande.type === this.typeDevis && this.ligneCommande.ligneReseau.anneeSemaine;
    },
    nbLignesLibelle() {
      if (this.ligneCommande.libelle) {
        return this.ligneCommande.libelle.split('\n').length;
      }
      return 1;
    },
    estProduitNumerique() {
      return this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE
        || this.ligneCommande.typeProduit === produitConf.CATEGORIE_ECRAN_NUMERIQUE;
    },
    estProduitReseauNumerique() {
      return this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE;
    },
    nbEcranAssocies() {
      let result = [];
      if (this.ligneCommande.produit.produitReseauNumerique.affectationsReseauEcran.length) {
        result = this.ligneCommande.produit
          .produitReseauNumerique.affectationsReseauEcran.filter((affectation) => {
            const dateFinLiaison = affectation.dateFin ? new Date(affectation.dateFin)
              : INFINITE_DAY;
            return moment(this.ligneCommande.dateDebut).isSameOrAfter(moment(affectation.dateDebut))
              && moment(this.ligneCommande.dateFin).isSameOrBefore(dateFinLiaison);
          });
      }
      return result.length;
    },
    showInputQuantiteDispo() {
      return this.ligneCommande.typeProduit === produitConf.CATEGORIE_UNITAIRE;
    },
    showSpecProduitReseau() {
      return [
        produitConf.CATEGORIE_REGROUPEMENT,
        produitConf.CATEGORIE_REGROUPEMENT_LC,
        produitConf.CATEGORIE_REGROUPEMENT_MAIRIE,
      ].includes(this.ligneCommande.typeProduit);
    },
    labelInputQuantiteDispo() {
      switch (this.ligneCommande.typeProduit) {
        case produitConf.CATEGORIE_UNITAIRE:
          return this.$t('detail.article.quantiteDispo');
        case produitConf.CATEGORIE_REGROUPEMENT_LC:
          return this.$t('detail.article.pourcentageVente');
        default:
          return '';
      }
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    toggleDetail(value) {
      this.openDetail = value ?? !this.openDetail;
    },
    updateParution() {
      updateDatesAllEcheancierAuto(this.devisCommande);
    },
    updateTypeRemiseLocal() {
      if (this.$refs.ligneRegroupement) {
        this.$refs.ligneRegroupement.forEach((ligne) => {
          ligne.updateTypeRemiseLocal();
        });
      }
    },
    async calculAutoTlpe() {
      try {
        await calculTlpe(
          this.ligneCommande,
          this.estSurFacture,
          this.periodeTotalCalculTlpeAuto,
          this.devisCommande.repartitionPayeurSurFacture,
        );
        this.calcul();
      } catch (e) {
        this.ligneCommande.lignesCommande.forEach((el) => {
          if (el.typeProduit === produitConf.CATEGORIE_DIVERS && el.calculAutomatiqueTlpe
            && el.produit.produitDivers.tlpe) {
            el.prixUnitaire = 0;
          }
        });
        this.calcul();
      }
    },
    updateMasqueLigne(lignes) {
      lignes.forEach((ligne) => { ligne.masqueLigne = false; });
    },
    calculerSurfaceDispo() {
      if (this.ligneCommande.isAffecteLogistiquement) return;
      this.ligneCommande.quantiteDispo = 0;
      updateQuantiteDispo(this.ligneCommande);
      this.quantiteDispo = this.ligneCommande.quantiteDispo * 100;
    },
    changeSaturation(saturation) {
      this.ligneCommande.quantiteDispo = saturationConvertisseur.toQuantiteDispo(saturation);
    },
    openPopupForDuplicate(ligneCommandePerso) {
      if (ligneCommandePerso) {
        this.errorPopUp = true;
        this.headerError = this.$i18n.t('dcf.messages.errors.duplicatePossibility');
      } else {
        this.popUpDuplicationLigne = true;
      }
    },
    async updateAffectationFace() {
      if (!this.ligneCommande.dateDebut || !this.ligneCommande.dateFin) {
        this.ligneCommande.affectation = [];
        return;
      }
      const affectationList = await getAffectionOfProductFace([this.ligneCommande]);
      this.ligneCommande.quantiteDispo = 0;
      await updateAffection(
        this.ligneCommande,
        this.devisCommande,
        affectationList[this.ligneCommande.produitId],
      );
    },
    async updateAffectationReseauLc() {
      if (!this.ligneCommande.dateDebut) {
        this.ligneCommande.affectation = [];
        return;
      }
      const affectationList = await getAffectionOfProductReseauLc([this.ligneCommande]);
      await updateAffection(
        this.ligneCommande,
        this.devisCommande,
        affectationList[this.ligneCommande.produitId],
      );
    },
    async updatePeriodeLocation(eventArgument) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (!eventArgument || !eventArgument.prorataTemporisDateQuantite) {
          const nouveauxTarifs = await getTarifPourDateLocation(this.ligneCommande);
          nouveauxTarifs.forEach(t => {
            const ligneCommandeToUpdate = this.ligneCommande.lignesCommande.find(l => {
              return l.produitId === t.produitEnfantId;
            });
            if (ligneCommandeToUpdate) {
              ligneCommandeToUpdate.dateDebut = this.ligneCommande.dateDebut;
              ligneCommandeToUpdate.dateFin = this.ligneCommande.dateFin;
              if (t.prixUnitaire) {
                ligneCommandeToUpdate.prixUnitaire = t.prixUnitaire;
              }
              if (this.ligneCommande.ligneReseau) {
                ligneCommandeToUpdate.ligneReseau = cloneDeep(this.ligneCommande.ligneReseau);
              }
            }
          });
          if (this.ligneCommande.typeProduit === produitConf.CATEGORIE_UNITAIRE
          || this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_LC) {
            setPrixUnitaireTlpe(this.ligneCommande.lignesCommande.filter((ligneCommande) => {
              return ligneCommande.produit && ligneCommande.produit.produitDivers
                && !ligneCommande.calculAutomatiqueTlpe
                && ligneCommande.produit.produitDivers.tlpe;
            }), this.ligneCommande.produit.liaisonsTarif);
            updateTarifProduitDiversTlpe(
              this.ligneCommande.dateDebut,
              this.ligneCommande.dateFin,
              this.ligneCommande.lignesCommande.filter((ligneCommande) => {
                return ligneCommande.produit && ligneCommande.produit.produitDivers
                  && !ligneCommande.calculAutomatiqueTlpe
                  && ligneCommande.produit.produitDivers.tlpe;
              }),
            );
          }
        }
        updateDateLigneCommande(this.ligneCommande, cloneDeep(this.ligneCommande.dateDebut),
          cloneDeep(this.ligneCommande.dateFin));
        updateDatesAllEcheancierAuto(this.devisCommande);
        if (this.ligneCommande.typeProduit === produitConf.CATEGORIE_UNITAIRE) {
          await this.updateAffectationFace();
        } else if (this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_LC) {
          await this.updateAffectationReseauLc();
        }
        updateQuantiteDispo(this.ligneCommande);
        this.quantiteDispo = this.ligneCommande.quantiteDispo * 100;
        this.calcul();
        if (this.devisCommande.type !== devisConf.TYPE_FACTURE) {
          await this.getDisponibilite(this.ligneCommande);
        }
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        throw e;
      }
      try {
        await calculTlpe(this.ligneCommande, this.estSurFacture,
          this.periodeTotalCalculTlpeAuto,
          this.devisCommande.repartitionPayeurSurFacture);
        this.calcul();
      } catch (e) {
        this.ligneCommande.lignesCommande.forEach((el) => {
          if (el.typeProduit === produitConf.CATEGORIE_DIVERS && el.calculAutomatiqueTlpe
            && el.produit.produitDivers.tlpe) {
            el.prixUnitaire = 0;
          }
        });
        this.calcul();
      }
    },
    associer() {
      const ordre = ordreAddInRegroupement(this.ligneCommande);
      // on divise par 100 car la generation de ligne multiplie par 100
      const nouvelleLigne = genererLigneCommande(ordre / 100);
      if (this.devisCommande.role === REGIE || this.devisCommande.role === MANDATAIRE_PAYEUR) {
        nouvelleLigne.aFacturer = true;
      }
      miseAJourArticle(nouvelleLigne, this.getRemiseTvaDefaut);
      nouvelleLigne.dateDebut = this.ligneCommande.dateDebut;
      copieReferencePersonnalise([nouvelleLigne], this.ligneCommande);
      if (this.isAvoirLibre && nouvelleLigne.quantite > 0) {
        nouvelleLigne.quantite *= -1;
      }
      this.ligneCommande.lignesCommande.push(nouvelleLigne);
      addReferenceEcheancierToLigneCommande(nouvelleLigne, this.devisCommande);
      gestionTarifUnitaire.toggleTarifUnitaire(this.ligneCommande);
    },
    associerCommentaire() {
      const ordre = ordreAddInRegroupement(this.ligneCommande);
      // on divise par 100 car la generation de ligne multiplie par 100
      const nouvelleLigne = genererLigneCommande(ordre / 100);
      miseAJourCommentaire(nouvelleLigne);
      copieReferencePersonnalise([nouvelleLigne], this.ligneCommande);
      this.ligneCommande.lignesCommande.push(nouvelleLigne);
    },
    async selectedProduct(option) {
      if (option) {
        if (!option.id) {
          this.$refs['autocomplete_' + this.ligneCommande.ordre].setSelected(null);
          return;
        }
        let nouvelleLigneCommande = [];
        if (option.type === produitConf.CATEGORIE_UNITAIRE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitFace(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauTempo(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT_LC) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauLc(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT_MAIRIE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauMairie(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauNumeriqueViaId(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_ECRAN_NUMERIQUE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitEcranNumeriqueViaId(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_SALON) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitSalon(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_SPONSORING) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitSponsoring(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_AUTRE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitAutre(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_PRESSE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitPresse(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else {
          nouvelleLigneCommande.push(genererLigneCommande(this.ligneCommande.ordre / 100));
          miseAJourArticle(nouvelleLigneCommande[0]);
          updateInfoSousLigneRegroupement(option, nouvelleLigneCommande[0], true,
            this.getRemiseTvaDefaut);
          nouvelleLigneCommande[0].produitId = option.id;
          nouvelleLigneCommande[0].typeProduit = option.type;
          nouvelleLigneCommande[0].produit = option.produit;
        }
        copieReferencePersonnalise(nouvelleLigneCommande, this.ligneCommande);
        addReferenceEcheancierToLigneCommande(nouvelleLigneCommande[0], this.devisCommande);
        this.$emit('modificationLigneCommande', nouvelleLigneCommande, this.ligneCommande.ordre, option.type);
      }
    },
    searchProduct: debounce(async function searchProductC() {
      if (this.ligneCommande.produit
        && this.ligneCommande.produit.reference
        && this.ligneCommande.produit.reference.length >= 3) {
        this.fetched = true;
        this.typesProduit = await getAllProduct(
          this.ligneCommande.produit.reference,
          this.getCategoriesProduct,
          this.sens,
          this.$route.params.id ? this.devisCommande.societeId : this.societeActiveId,
          this.filtrerProduitParSociete,
        );
      } else {
        this.typesProduit = [];
        this.fetched = false;
      }
    }, 500),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    calcul() {
      this.$emit('reloadTotalHt');
    },
    async checkValidationLigneCommandeForDelete(ids) {
      if (!ids?.filter(id => !!id && id !== GUID_VIDE).length) return;
      try {
        const ligneCommandeIds = ids.filter(id => !!id);
        await checkValidationLigneCommandeForDeleteAsync({ ligneCommandeIds });
      } catch (e) {
        const messages = [];
        validationLigneCommandeDemandeLogistique(e.response, messages);
        this.$emit('messagesErrors', messages);
        throw e;
      }
    },
    async supprimerProduit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.checkValidationLigneCommandeForDelete([this.ligneCommande.id]);
        if (this.isLigneRegroupementReseauInDevisWithValidationModifBlocage) {
          const message = this.devisCommande.type === devisConf.TYPE_DEVIS
            ? 'validationDevis.suppProduitRegroupementInDevisWithValidationModifBlocage'
            : 'validationCommande.suppProduitRegroupementInDevisWithValidationModifBlocage';
          messageErreur(this.$i18n, this.$i18n.t(message));
          return;
        }
        if (this.isLigneRegroupementReseauInCreateCommandeFromDevis) {
          messageErreur(this.$i18n, this.$i18n.t('validationCommande.suppProduitRegroupementInCreateCommandeFromDevis'));
          return;
        }
        this.lignesCommande.splice(this.lignesCommande.indexOf(this.ligneCommande), 1);
        deleteLignesEcheanciersInutiles(this.devisCommande);
        this.$emit('reloadTotalHt');
      } finally {
        loadingComponent.close();
      }
    },
    async getDisponibilite(ligneRegroupement) {
      const dateDebut = ligneRegroupement.dateDebut;
      const dateFin = ligneRegroupement.dateFin;
      if (this.devisCommande.type !== devisConf.TYPE_FACTURE) {
        this.disponibilite = await getDisponibilite(ligneRegroupement, dateDebut, dateFin);
      }
    },
    reloadSimulationEtatProv() {
      if (this.$refs.ligneOptionBlocage) this.$refs.ligneOptionBlocage.simulationEtatObtenuAsync();
    },
    makeDuplication(qte = 1) {
      this.devisCommande.lignesCommande.sort((a, b) => a.ordre - b.ordre);
      const findIndex = this.devisCommande.lignesCommande.findIndex(
        (ligne) => ligne.ordre === this.ligneCommande.ordre,
      );
      const ligneOriginale = this.devisCommande.lignesCommande[findIndex];
      const lignes = [];
      let ordre = ligneOriginale.ordre;

      // Fonction utilitaire pour nettoyer les champs spécifiques
      const nettoyerChamps = (ligne) => {
        delete ligne.id;
        delete ligne.referenceRegroupement;
        delete ligne.referenceEcheancier;
        ligne.selected = false;
        ligne.isDuplicated = true;

        if (ligne.lignesCommande) {
          ligne.lignesCommande.forEach((sousLigne) => {
            delete sousLigne.id;
            delete sousLigne.referenceEcheancier;
            sousLigne.lignesRemise.forEach((ligneRemise) => {
              delete ligneRemise.id;
            });
          });
        }
      };
      for (let i = 0; i < qte; i += 1) {
        const clone = cloneDeep(ligneOriginale);
        nettoyerChamps(clone);

        ordre += 100;
        clone.ordre = ordre;
        initialisationOptionBlocage(clone);
        addReferenceEcheancierToLigneCommande(clone, this.devisCommande);

        lignes.push(clone);
      }
      this.devisCommande.lignesCommande.splice(findIndex + 1, 0, ...lignes);
      this.devisCommande.lignesCommande.sort((a, b) => a.ordre - b.ordre);
      this.calcul();
    },
  },
  inject: ['allOpen'],
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.openDetail = this.allOpen();
    try {
      this.disponibilite = cloneDeep(this.disponibiliteTempo);
      if (this.estProduitNumerique) {
        this.saturation = saturationConvertisseur.toSaturation(this.ligneCommande.quantiteDispo);
      }
      if (!this.ligneCommande.id
        && (!this.ligneCommande.etatObtenu
        || this.ligneCommande.etatObtenu === AUCUN)
        && this.$refs.ligneOptionBlocage) {
        this.$refs.ligneOptionBlocage.simulationEtatObtenuAsync();
      }
      await this.loadParametresInterne(
        [PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
